import { Component, EventEmitter, Output } from '@angular/core';
import { ContractCollectionComponent } from '../contract-collection.component';
import { AdminContractService, CollectionApi, ContractOrganization } from '@shared/services/admin-contract.service';
import { ToastrService } from '@shared/services/toastr.service';
import { ADMIN_PREFIX } from '../../../../../app-routing.constants';
import { ORGANIZATIONS_ROUTE } from '../../../admin-routing.module';
import { AdminOrganizationSelectorComponent } from '@shared/components/admin-organization-selector/admin-organization-selector.component';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { RouterLink } from '@angular/router';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-contract-organizations',
  templateUrl: './contract-organizations.component.html',
  styleUrls: ['./contract-organizations.component.scss'],
  imports: [
    AdminOrganizationSelectorComponent,
    NgxDatatableModule,
    TypedTemplateDirective,
    RouterLink,
    BadgeOrganizationComponent,
    TablePagerComponent,
    TranslatePipe,
  ],
})
export class ContractOrganizationsComponent extends ContractCollectionComponent<ContractOrganization> {
  @Output() refreshSites = new EventEmitter<void>();

  constructor(
    admin: AdminContractService,
    private toaster: ToastrService,
  ) {
    super(admin);
  }

  override getCollectionApi(): CollectionApi<ContractOrganization> {
    return this.admin.organizations(this.contractNumber);
  }

  protected getItemId(item: ContractOrganization) {
    return item.code;
  }

  async linkSites(item: ContractOrganization) {
    this.admin.linkSites(this.contractNumber, item.code).subscribe((res) => {
      this.toaster.success(['Contract.sitesAdded', { n: res.addedSites.length }]);
    });
  }

  protected readonly ADMIN_PREFIX = ADMIN_PREFIX;
  protected readonly ORGANIZATIONS_ROUTE = ORGANIZATIONS_ROUTE;
}
